<template>
    <div>
        <div class="form-group row">
            <label class="col-form-label font-weight-semibold" :class="{'text-danger':validClass,'col-lg-3':vertical}" v-if="label">{{label}}</label>
            <div :class="{'col-lg-9':vertical}">
                <input :type="type" class="form-control-uniform-custom" :accept="accept" ref="fileInput" v-model="fileName" @change="changeFile" id="file">
                <span class="form-text text-muted" v-if="description"> - {{description}}</span>
                <span class="form-text" :class="{'border-danger':validClass,'text-danger':validClass}" v-for="resultStr in validationResult" :key="resultStr">{{resultStr}}</span>
                <span v-if="downloadName && downloadLocation"><i class="icon-info22 mr-2"/><a :href="downloadLocation">{{downloadName}}</a></span>
            </div>
        </div>
    </div>
</template>

<script>
    import validation from "@/config/mixin/validation";
    export default {
        name: "BasicFileInput",
        mixins:[validation],
        props: {
            label: {
                type: String,
            },
            vertical: {
                type: Boolean
            },
            rule: {
                type: String
            },
            description: {
                type: String
            },
            accept: {
                type: String,
                required: true
            },
            downloadName: {
                type: String
            },
            downloadLocation: {
                type: String
            }
        },
        data(){
            return {
                file: null,
                type: 'file',
                fileName:''
            }
        },
        mounted() {
        },
        methods: {
            validator: function() {
                this.validationResult = this.getValidationResult(this.rule,this.file,this.type)
                if(this.rule.includes('required')) {
                    if(!this.file || this.validClass) {
                        document.getElementsByClassName('filename')[0].classList.add('border-danger')
                    } else {
                        document.getElementsByClassName('filename')[0].classList.remove('border-danger')
                    }
                }
                return this.validationResult
            },
            changeFile:function(e) {
                let files = e.target.files
                if(e.target.files.length> 0) {
                    this.file = e.target.files[0]
                    this.$emit('change',this.file)
                }
            },
          // reset: function () {
          //     console.log("---send.reset call---")
          //   // var input = $('#file')
          //   // input.replaceWith(input.val('').clone(true));
          //   $("#filename").val("");
          //   this.resetValidationResult()
          //
          // }
        },
        computed: {
            validClass: function() {
                return this.validationResult.length > 0
            }
        },
        watch: {
            'file':function(file) {
                this.validator()
            },
            'fileName': function(val) {
                if(!val) this.file = null
            }
        }
    }
</script>

<style scoped>

</style>
